import {
  AfterContentInit,
  AfterViewChecked,
  ContentChild,
  Directive,
  ElementRef,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[overflowShadow]',
})
export class OverflowShadowDirective implements AfterContentInit, AfterViewChecked {
  @ContentChild('overflowShadowObservedElement') observedElement: ElementRef;
  alpha = 0;
  shadowTopEl;
  shadowBottomEl;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngAfterContentInit(): void {
    if (this.observedElement) {
      this.createElements();

      const hasVerticalScrollbar =
        this.observedElement.nativeElement.scrollHeight >
        this.observedElement.nativeElement.clientHeight;

      if (hasVerticalScrollbar) {
        this.renderer.setStyle(this.shadowBottomEl, 'opacity', '1');
      }

      this.renderer.listen(this.observedElement.nativeElement, 'scroll', (event) => {
        this.onScroll(event);
      });
    }
  }

  ngAfterViewChecked(): void {
    this.validateHeight();
  }

  createElements(): void {
    this.shadowTopEl = this.renderer.createElement('div');
    this.renderer.setStyle(
      this.shadowTopEl,
      'background',
      'linear-gradient(0deg, #ffffff00 70%, #cccccc)'
    );
    this.renderer.setStyle(this.shadowTopEl, 'top', '0');
    this.setProperties(this.shadowTopEl);

    this.shadowBottomEl = this.renderer.createElement('div');
    this.renderer.setStyle(
      this.shadowBottomEl,
      'background',
      'linear-gradient(0deg, #cccccc, #ffffff00 70%)'
    );
    this.renderer.setStyle(this.shadowBottomEl, 'bottom', '0');
    this.setProperties(this.shadowBottomEl);

    this.renderer.appendChild(this.elementRef.nativeElement, this.shadowTopEl);
    this.renderer.appendChild(this.elementRef.nativeElement, this.shadowBottomEl);
  }

  validateHeight(): void {
    if (!this.observedElement) {
      return;
    }

    const hasVerticalScrollbar =
      this.observedElement.nativeElement.scrollHeight >
      this.observedElement.nativeElement.clientHeight;

    const topShadowStyle = getComputedStyle(this.shadowTopEl).opacity;
    const bottomShadowStyle = getComputedStyle(this.shadowBottomEl).opacity;
    const shadowsHidden = topShadowStyle === '0' && bottomShadowStyle === '0';

    if (!hasVerticalScrollbar) {
      this.renderer.setStyle(this.shadowTopEl, 'opacity', '0');
      this.renderer.setStyle(this.shadowBottomEl, 'opacity', '0');
    } else if (hasVerticalScrollbar && shadowsHidden) {
      this.renderer.setStyle(this.shadowBottomEl, 'opacity', '1');
    }
  }

  onScroll(event): void {
    const hasVerticalScrollbar =
      this.observedElement.nativeElement.scrollHeight >
      this.observedElement.nativeElement.clientHeight;

    if (hasVerticalScrollbar) {
      const scrollDistance = event.target.scrollTop;

      const height = event.target.scrollHeight - event.target.clientHeight;
      this.alpha = scrollDistance / height;

      this.renderer.setStyle(this.shadowTopEl, 'opacity', this.alpha);
      this.renderer.setStyle(this.shadowBottomEl, 'opacity', 1 - this.alpha);
    }
  }

  setProperties(element): void {
    const styleProperties = [
      ['position', 'absolute'],
      ['height', '100px'],
      ['left', '-0'],
      ['display', 'flex'],
      ['overflow-x', 'hidden'],
      ['width', '100%'],
      ['opacity', '0'],
      ['z-index', '-10'],
    ];

    styleProperties.forEach((style) => {
      this.renderer.setStyle(element, style[0], style[1]);
    });
  }
}
